import Cookies from 'universal-cookie';
import { ITokens } from '../interfaces';
import { AppConfig, storageKey } from './AppContext';

export enum ActionType {
  SET_EMAIL = 'SET_EMAIL',
  SET_TOKENS = 'SET_TOKENS',
  LOGOUT = 'LOGOUT',
}

export type Action = {
  type: ActionType;
  payload: unknown;
};

const setCookie = (state: AppConfig): void => {
  new Cookies().set(storageKey, state, { path: '/', maxAge: 2629743.83, sameSite: true, secure: true });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const reducer: React.Reducer<AppConfig, Action> = (prevState, action): any => {
  switch (action.type) {
    case ActionType.SET_EMAIL: {
      const newState = { ...prevState, email: action.payload as string };

      setCookie(newState);
      return newState;
    }
    case ActionType.SET_TOKENS: {
      const newState = {
        ...prevState,
        accessToken: (action.payload as ITokens).accessToken,
        refreshToken: (action.payload as ITokens).refreshToken,
      };

      setCookie(newState);
      return newState;
    }
    case ActionType.LOGOUT: {
      new Cookies().remove(storageKey, { path: '/' });
      return { ...(action.payload as AppConfig) };
    }
    default:
      return prevState;
  }
};
